import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ConstipationPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Constipation</h1>
        <section className="mb-8">
          <p>Constipation is a common digestive problem characterized by infrequent or difficult bowel movements. Our natural therapies focus on improving digestion, regulating bowel movements, and promoting gut health through herbal remedies and lifestyle changes.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Poor dietary habits</li>
            <li>Low fiber intake</li>
            <li>Dehydration</li>
            <li>Physical inactivity</li>
            <li>Ignoring the urge to go</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Infrequent bowel movements</li>
            <li>Hard or dry stools</li>
            <li>Abdominal discomfort</li>
            <li>Bloating</li>
            <li>Straining during bowel movements</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use digestive herbs, fiber-rich remedies, and lifestyle modifications to naturally treat constipation. Our approach focuses on improving digestion, regulating bowel movements, and promoting gut health through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Improved digestion</li>
            <li>Regular bowel movements</li>
            <li>No harsh side effects</li>
            <li>Long-term gut health</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat a high-fiber diet</li>
            <li>Drink plenty of water</li>
            <li>Exercise regularly</li>
            <li>Establish a regular bathroom routine</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within a few days to a week of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for children and elderly?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for all age groups.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by addressing root causes and promoting healthy habits.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from constipation—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default ConstipationPage; 